import { cdnImage } from "../../helper/constants";
import "./Style.css";
const DownloadApp = ({ download, hidePopup }) => {

  const handleNavigation = (link = "") => {
    window.open(link, "_blank");
  };

  return (
    <div className="outer-container download-container-wrap">
      <button className="close" onClick={hidePopup}>
        x
      </button>
      <div className="download-container">
        <div className="airtel-icon-container">
          <img
            src={download?.logoImg}
            className="airtel-icon"
          ></img>
        </div>
        <div class="inner-container">
          <p>
            <span className="inner-title">{download?.title}</span>
            <span className="inner-text">{download?.text}</span>
          </p>
        </div>
      <div className="downloadWrap">
      <button
          className="download"
          onClick={() => handleNavigation(download?.link)}
        >
          {download?.linkTitle}
        </button>
      </div>
      </div>
    </div>
  );
};

export default DownloadApp;
